<template>
    <div>
        <HeaderTopComponent v-if="!menuMovil" />
        <MenuComponent 
            background='' 
            :dense='false' 
            styleRow='margin-top: 0px'
            v-if="!menuMovil"
        />
        <MenuMovilComponent v-if="menuMovil" class='px-6 px-sm-10'/>
        <v-img 
            :src="`${require('@/assets/banner-sedes.png')}`" 
            v-if="$route.path != '/servicios/pacientes/medicamentos-especialidad'"
            :class="`${scrollTop ? '' : 'mt-132'}`"
        />
        <BreadCrumbsComponent :breadcrumbs="breadcrumbs" class="margin-breadcrumb"/>
        <div 
            class="mx-5 mx-sm-10 mx-md-16 px-md-16 my-6" 
            v-if="$route.path == '/sedes'"
        >
            <v-row>
                <v-col cols="12" md="6">
                    <h2 class="font-size-custom font-weight-bold color-title font-title"><i>Sedes Quito</i></h2>
                    <div  class="pointer-card-services mt-10">
                        <CardServiciosComponent 
                            classCard='color-border-card'
                            :icon="require('@/assets/Sedes-Farmacia.png')"
                            title="<div class='text-body-1 text-sm-h5 text-md-h5 gray--text '><b>FARMACIA</b></div>"
                            link="/sedes/farmacia-quito"  
                        />
                    </div>
                    <div  class="pointer-card-services mt-10">
                        <CardServiciosComponent 
                            classCard='color-border-card'
                            :icon="require('@/assets/Sedes-CDA.png')"
                            title="<div class='text-body-1 text-sm-h5 text-md-h5 gray--text '><b>CENTRO DE APLICACIONES</b></div>"
                            link="/sedes/centro-aplicaciones-quito"
                            class='mt-8'
                        />
                    </div>
                    <!-- <div  class="pointer-card-services mt-10">
                        <CardServiciosComponent 
                            classCard='color-border-card'
                            :icon="require('@/assets/Sedes-LAB.png')"
                            title="<div class='text-body-1 text-sm-h5 text-md-h5 gray--text '><b>LABORATORIO</b></div>"
                            link="/sedes/laboratorio-quito"
                            class='mt-8'  
                        />
                    </div> -->
                </v-col>
                <v-col cols="12" md="6">
                    <h2 class="font-size-custom font-weight-bold color-title font-title"><i>Sedes Guayaquil</i></h2>
                    <div  class="pointer-card-services mt-10">
                        <CardServiciosComponent 
                            classCard='color-border-card'
                            :icon="require('@/assets/Sedes-Farmacia.png')"
                            title="<div class='text-body-1 text-sm-h5 text-md-h5 gray--text '><b>FARMACIA</b></div>"
                            link="/sedes/farmacia-guayaquil"  
                        />
                    </div>
                    <div  class="pointer-card-services mt-10">
                        <CardServiciosComponent 
                            classCard='color-border-card'
                            :icon="require('@/assets/Sedes-CDA.png')"
                            title="<div class='text-body-1 text-sm-h5 text-md-h5 gray--text'><b>CENTRO DE APLICACIONES</b></div>"
                            link="/sedes/centro-aplicaciones-guayaquil"
                            class='mt-8'
                        />
                    </div>
                </v-col>
            </v-row>
        </div>
        <router-view @newBreadcrumbs=newBreadcrumbs></router-view>
        <FooterComponent />
    </div>
</template>

<script>
import HeaderTopComponent from '../partials/HeaderTopComponent'
import MenuComponent from '../partials/MenuComponent'
import FooterComponent from '../partials/FooterComponent'
import BreadCrumbsComponent from '../partials/BreadCrumbsComponent'
import CardServiciosComponent from '../partials/CardServiciosComponent'
import MenuMovilComponent from '../partials/MenuMovilComponent'
import {mapState} from 'vuex'

export default {
    name:'IndexComponent',
    data: ()=>({
        breadcrumbs:[
            {name:'Inicio',url:'/'},
            {name:'Sedes',url:'/sedes'}
        ]  
    }),
    components:{
        HeaderTopComponent,
        MenuComponent,
        FooterComponent,
        BreadCrumbsComponent,
        CardServiciosComponent, 
        MenuMovilComponent
    },
    watch:{
        $route(to) {
             if(to.path == '/sedes') 
                this.breadcrumbs = [
                    {name:'Inicio',url:'/'},
                    {name:'Sedes',url:'/sedes'}
                ]  
        }
    },
    computed:{
        menuMovil(){
            return this.$vuetify.breakpoint.name == 'sm' || this.$vuetify.breakpoint.name == 'xs'
        },

        ...mapState(['scrollTop'])
    },
    methods:{
        newBreadcrumbs(newBreadcrumbs){
            this.breadcrumbs = newBreadcrumbs
        }
    },
    created(){
           
    }
}
</script>

<style>
    .pointer-card-services{
        cursor: pointer;
    }
    .color-border-card{
        border: 3px solid #50c995!important;
        border-radius: 20px!important;
    }
    .img-dialog-description{
        max-width: 70px;
        background: #ffaa45;
        padding: 8px;
        border-radius: 10px;
    }
    .v-application .text-md-h3, .v-application .text-md-h5{
        font-family: Asap!important
    }

    .row{
        width: 100%;
    }
    
</style>